// Installation phases for sales presentation mode
export const INSTALLATION_PHASES = [
  {
    id: 'phase-1',
    key: 'Phase 1: Site Protection & Setup',
    title: 'Site Protection & Setup',
    number: 1,
    description: 'Protecting your property during the installation process',
    customerExplanation: 'We take care to protect your landscaping, driveway, and property throughout the project.',
    icon: 'Shield',
  },
  {
    id: 'phase-2',
    key: 'Phase 2: Tear-Off & Deck Prep',
    title: 'Tear-Off & Deck Prep',
    number: 2,
    description: 'Removing old roofing materials and preparing the deck',
    customerExplanation: 'We carefully remove old shingles and inspect/repair the roof deck to ensure a solid foundation.',
    icon: 'Hammer',
  },
  {
    id: 'phase-3',
    key: 'Phase 3: Edge Protection',
    title: 'Edge Protection (Drip Edges)',
    number: 3,
    description: 'Installing drip edges on eaves and rakes',
    customerExplanation: 'Drip edges prevent water from getting under shingles and rotting your fascia boards.',
    icon: 'Shield',
  },
  {
    id: 'phase-4',
    key: 'Phase 4: Leak Barriers',
    title: 'Leak Barriers (Ice & Water Shield)',
    number: 4,
    description: 'Installing ice and water shield protection',
    customerExplanation: 'Ice & water shield protects vulnerable areas like valleys, eaves, and around penetrations from water damage.',
    icon: 'Droplets',
  },
  {
    id: 'phase-5',
    key: 'Phase 5: Field Underlayment',
    title: 'Field Underlayment',
    number: 5,
    description: 'Installing protective underlayment across the roof',
    customerExplanation: 'High-quality underlayment provides an extra layer of protection beneath your shingles.',
    icon: 'Layers',
  },
  {
    id: 'phase-6',
    key: 'Phase 6: Valley Systems',
    title: 'Valley Systems',
    number: 6,
    description: 'Installing valley protection',
    customerExplanation: 'Valleys channel water off your roof - we use the best materials to prevent leaks in these critical areas.',
    icon: 'ArrowDown',
  },
  {
    id: 'phase-7',
    key: 'Phase 7: Starter Courses',
    title: 'Starter Courses',
    number: 7,
    description: 'Installing starter strips along edges',
    customerExplanation: 'Starter strips ensure your first row of shingles seals properly and resists wind uplift.',
    icon: 'AlignStartVertical',
  },
  {
    id: 'phase-8',
    key: 'Phase 8: Flashings & Walls',
    title: 'Flashings & Walls',
    number: 8,
    description: 'Installing flashings at walls and transitions',
    customerExplanation: 'Professional flashing prevents water intrusion where your roof meets walls, chimneys, and other structures.',
    icon: 'WallBrick',
  },
  {
    id: 'phase-9',
    key: 'Phase 9: Penetrations',
    title: 'Penetrations',
    number: 9,
    description: 'Sealing pipes, vents, and skylights',
    customerExplanation: 'Every pipe, vent, and skylight is properly sealed to prevent leaks.',
    icon: 'Circle',
  },
  {
    id: 'phase-10',
    key: 'Phase 10: Attic Ventilation',
    title: 'Attic Ventilation',
    number: 10,
    description: 'Installing ventilation system',
    customerExplanation: 'Proper ventilation extends shingle life and reduces cooling costs by regulating attic temperature.',
    icon: 'Wind',
  },
  {
    id: 'phase-11',
    key: 'Phase 11: Shingle Field',
    title: 'Shingle Field',
    number: 11,
    description: 'Installing your chosen shingles',
    customerExplanation: 'This is where your roof comes to life! Choose the shingle that matches your style and budget.',
    icon: 'Home',
    isHero: true as const,
  },
  {
    id: 'phase-11.5',
    key: 'Phase 11.5: Shingle Color',
    title: 'Shingle Color',
    number: 11.5,
    description: 'Select your shingle color',
    customerExplanation: 'Choose the perfect color to complement your home\'s exterior.',
    icon: 'Palette',
    requiresPriorSelection: true as const,
    requiredPhaseKey: 'Phase 11: Shingle Field' as const,
  },
  {
    id: 'phase-12',
    key: 'Phase 12: Hips & Ridges',
    title: 'Hips & Ridges',
    number: 12,
    description: 'Installing ridge cap shingles',
    customerExplanation: 'Ridge cap shingles provide the finishing touch and seal the peak of your roof.',
    icon: 'Triangle',
  },
  {
    id: 'phase-13',
    key: 'Phase 13: Perimeter Finish',
    title: 'Perimeter Finish',
    number: 13,
    description: 'Final touches and perimeter work',
    customerExplanation: 'We add finishing touches like paint, masonry work, and heat cable if needed.',
    icon: 'Paintbrush',
  },
  {
    id: 'phase-14',
    key: 'Phase 14: Gutters',
    title: 'Gutters (Optional)',
    number: 14,
    description: 'New gutter system',
    customerExplanation: 'New gutters protect your foundation and landscaping by directing water away from your home.',
    icon: 'Waves',
    isOptional: true as const,
  },
  {
    id: 'phase-15',
    key: 'Phase 15: Cleanup & Warranty',
    title: 'Cleanup & Warranty',
    number: 15,
    description: 'Final cleanup and warranty registration',
    customerExplanation: 'We do a thorough magnetic sweep for nails and register your manufacturer warranty.',
    icon: 'CheckCircle',
  },
] as const;

export type InstallationPhase = typeof INSTALLATION_PHASES[number];
